import { useOutletContext } from 'react-router-dom'
import type { SkillDetail } from '@/types'

export interface SkillDetailContext {
  projectId: string
  skill: SkillDetail | null
  canEdit: boolean
  displayName: string
  onDisplayNameChange: (value: string) => void
  internalName: string
  onInternalNameChange: (value: string) => void
  internalNameError: string | null
  showValidation: boolean
  description: string
  onDescriptionChange: (value: string) => void
  content: string
  onContentChange: (value: string) => void
  contentTooLong: boolean
  pendingAttachments: File[]
  onPendingAttachmentsChange: (files: File[]) => void
  isDirty: boolean
  isSaving: boolean
  saveBlockedReason: string | null
  onSave: () => void
  onCancel: () => void
}

export function useSkillDetailContext(): SkillDetailContext {
  return useOutletContext<SkillDetailContext>()
}
